import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ committeeRoleId = '', ...params }) => {
  return await dponetAPI.get(`/committee_roles/${committeeRoleId}`, {
    params,
  })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post(`/committee_roles`, data)
}

const update = async ({ committeeRoleId = '', ...data }) => {
  return await dponetAPI.put(`/committee_roles/${committeeRoleId}`, data)
}

const destroy = async ({ committeeRoleId = '' }) => {
  return await dponetAPI.delete(`/committee_roles/${committeeRoleId}`)
}

export default {
  get,
  create,
  update,
  destroy,
}
